/** @type {import("vuex").Module} */
export const node = {
    namespaced: true,

    state: {
        active: null,
        isEdit: false,
    },

    mutations: {
        setActive(state, value = null) {
            state.active = value;
        },
        setIsEdit(state, value = false) {
            state.isEdit = value;
        },
    },
    actions: {
        pullItem(store, item) {
            let form = store?.rootState?.employment?.form?.form || {};
            let fields = form?.fields || [];

            let index = fields.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) fields.splice(index, 1);

            store.commit("employment/form/setForm", { ...form, fields }, { root: true });
            store.commit("setActive");
        },
        updateItem(store, item) {
            let form = store?.rootState?.employment?.form?.form || {};
            let fields = form?.fields || [];

            let index = fields.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) fields.splice(index, 1, item);
            else fields.push(item);

            store.commit("employment/form/setForm", { ...form, fields }, { root: true });
        },
        reset(store) {
            store.commit("setActive");
        },
    },
};

export default node;
